<script>
import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.addPlugin({
      id: "my-plugin",
      beforeInit: function (chart) {
        var datasets = chart.data.datasets[0];
        var data = datasets ? datasets.data : [0];
        var isAllZero = data.reduce((a, b) => a + b) > 0 ? false : true;
        if (isAllZero && chart.data.datasets[0]) {
          chart.data.datasets[0].data = data.map((e, i) => (i > 0 ? 0 : 1)); //add one segment
          chart.data.datasets[0].backgroundColor = "#d2dee2"; //change bg color
          chart.data.datasets[0].borderWidth = 0; //no border
          chart.options.tooltips = false; //disable tooltips
          chart.options.legend.onClick = null; //disable legend click
        }
      },
    });
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },
};
</script>
